var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { IsBoolean, IsDefined, ValidateNested } from 'class-validator';
class ReservationVehicleChecklistTiresDto {
}
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], ReservationVehicleChecklistTiresDto.prototype, "frontLeft", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], ReservationVehicleChecklistTiresDto.prototype, "frontRight", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], ReservationVehicleChecklistTiresDto.prototype, "rearLeft", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], ReservationVehicleChecklistTiresDto.prototype, "rearRight", void 0);
class ReservationVehicleChecklistWipersDto {
}
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], ReservationVehicleChecklistWipersDto.prototype, "driver", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], ReservationVehicleChecklistWipersDto.prototype, "passenger", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], ReservationVehicleChecklistWipersDto.prototype, "rear", void 0);
class ReservationVehicleChecklistLightsDto {
}
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], ReservationVehicleChecklistLightsDto.prototype, "head", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], ReservationVehicleChecklistLightsDto.prototype, "tail", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], ReservationVehicleChecklistLightsDto.prototype, "brake", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], ReservationVehicleChecklistLightsDto.prototype, "turnSignal", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], ReservationVehicleChecklistLightsDto.prototype, "hazard", void 0);
class ReservationVehicleChecklistSideMirrorsDto {
}
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], ReservationVehicleChecklistSideMirrorsDto.prototype, "driver", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], ReservationVehicleChecklistSideMirrorsDto.prototype, "passenger", void 0);
class ReservationVehicleChecklistWindowsDto {
}
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], ReservationVehicleChecklistWindowsDto.prototype, "front", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], ReservationVehicleChecklistWindowsDto.prototype, "driver", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], ReservationVehicleChecklistWindowsDto.prototype, "passenger", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], ReservationVehicleChecklistWindowsDto.prototype, "rearLeft", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], ReservationVehicleChecklistWindowsDto.prototype, "rearRight", void 0);
class ReservationVehicleChecklistSeatBeltsDto {
}
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], ReservationVehicleChecklistSeatBeltsDto.prototype, "driver", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], ReservationVehicleChecklistSeatBeltsDto.prototype, "frontPassenger", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], ReservationVehicleChecklistSeatBeltsDto.prototype, "rearLeft", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], ReservationVehicleChecklistSeatBeltsDto.prototype, "rearRight", void 0);
export class UpsertReservationVehicleChecklistDto {
    toItems() {
        return {
            safetyTriangle: this.safetyTriangle,
            tires: Object.assign({}, this.tires),
            wipers: Object.assign({}, this.wipers),
            lights: Object.assign({}, this.lights),
            sideMirrors: Object.assign({}, this.sideMirrors),
            windows: Object.assign({}, this.windows),
            seatBelts: Object.assign({}, this.seatBelts),
        };
    }
}
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], UpsertReservationVehicleChecklistDto.prototype, "safetyTriangle", void 0);
__decorate([
    IsDefined(),
    ValidateNested(),
    Type(() => ReservationVehicleChecklistTiresDto),
    __metadata("design:type", ReservationVehicleChecklistTiresDto)
], UpsertReservationVehicleChecklistDto.prototype, "tires", void 0);
__decorate([
    IsDefined(),
    ValidateNested(),
    Type(() => ReservationVehicleChecklistWipersDto),
    __metadata("design:type", ReservationVehicleChecklistWipersDto)
], UpsertReservationVehicleChecklistDto.prototype, "wipers", void 0);
__decorate([
    IsDefined(),
    ValidateNested(),
    Type(() => ReservationVehicleChecklistLightsDto),
    __metadata("design:type", ReservationVehicleChecklistLightsDto)
], UpsertReservationVehicleChecklistDto.prototype, "lights", void 0);
__decorate([
    IsDefined(),
    ValidateNested(),
    Type(() => ReservationVehicleChecklistSideMirrorsDto),
    __metadata("design:type", ReservationVehicleChecklistSideMirrorsDto)
], UpsertReservationVehicleChecklistDto.prototype, "sideMirrors", void 0);
__decorate([
    IsDefined(),
    ValidateNested(),
    Type(() => ReservationVehicleChecklistWindowsDto),
    __metadata("design:type", ReservationVehicleChecklistWindowsDto)
], UpsertReservationVehicleChecklistDto.prototype, "windows", void 0);
__decorate([
    IsDefined(),
    ValidateNested(),
    Type(() => ReservationVehicleChecklistSeatBeltsDto),
    __metadata("design:type", ReservationVehicleChecklistSeatBeltsDto)
], UpsertReservationVehicleChecklistDto.prototype, "seatBelts", void 0);
